import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from 'icons/close-icon.inline.svg';

import styles from './styles.module.scss';

const Modal = ({ title = undefined, message = undefined, onClosePress }) => (
  <div className={styles.overlay}>
    <div className={styles.inner}>
      <button className={styles.close} onClick={onClosePress} type="button">
        <CloseIcon />
      </button>
      {title && <h4>{title}</h4>}
      {message && <p>{message}</p>}
    </div>
  </div>
);


Modal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  onClosePress: PropTypes.func.isRequired,
};

export default Modal;
